import {createFeatureSelector, createSelector} from '@ngrx/store';
import {CUSTOMFIELDS_FEATURE_KEY, customFieldsAdapter, State,} from './custom-fields.reducer';

// Lookup the 'CustomFields' feature state managed by NgRx
export const getCustomFieldsState = createFeatureSelector<State>(
    CUSTOMFIELDS_FEATURE_KEY
);

const {selectAll, selectEntities} = customFieldsAdapter.getSelectors();

export const getCustomFieldsLoading = createSelector(
    getCustomFieldsState,
    (state: State) => state.loading
);

export const getCustomFieldsError = createSelector(
    getCustomFieldsState,
    (state: State) => state.error
);

export const getAllCustomFields = createSelector(
    getCustomFieldsState,
    (state: State) => selectAll(state)
);

export const getCustomFieldsEntities = createSelector(
    getCustomFieldsState,
    (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getCustomFieldsState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getCustomFieldsEntities,
    getSelectedId,
    (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);
